import React from 'react'
import NewsPage from './NewsPage'
import ResponsiveCarousel from './ResponsiveCarousel'
import ScrollUpButton from 'react-scroll-up-button'

const TopPage = () => (
  <div className='top'>
    <section className='carousel'>
      <ResponsiveCarousel />
    </section>
    <section className='banner'>
      <a href='/about'>
        <img src='images/feature_banner.svg' alt='' width='100%' />
      </a>
    </section>
    <section className='main'>
      <div className='main-row'>
        <a href='/flow' className='main-cell'>
          <p className='text'><i className="fas fa-briefcase"></i> 入居までの流れ</p>
        </a>
        <a href='/shop' className='main-cell'>
          <p className='text'><i className="fas fa-coffee"></i> 駄菓子屋への思い</p>
        </a>
      </div>
      <div className='main-row'>
        <a href='/detail' className='main-cell'>
          <p className='text'><i className="fas fa-home"></i> 間取り・家賃</p>
        </a>
        <a href='/access' className='main-cell'>
          <p className='text'><i className="fas fa-subway"></i> アクセス</p>
        </a>
      </div>
      <div className='main-row'>
        <a href='/contact' className='main-cell main-no-border'>
          <p className='text'><i className="far fa-envelope"></i> お問い合わせ</p>
        </a>
        <a href='/faq' className='main-cell main-no-border'>
          <p className='text'><i className="fas fa-question-circle"></i> よくあるご質問</p>
        </a>
      </div>
    </section>
    <section id='news' className='news'>
      <NewsPage />
    </section>
    <section id='photos' className='photos'>
      <h2>Photo Gallery</h2>
      <div className='photos-row'>
        <a className='photos-cell photos-num1' href='/photosShop'>
          <p className='title'>駄菓子屋</p>
          <p className='sub-title'>小・中学校から近く</p>
          <p className='description'>昔懐かしのお店</p>
          <i className="fas fa-angle-down"></i>
        </a>
        <a className='photos-cell photos-num2' href='/photosRoom'>
          <p className='title'>18畳のリビング</p>
          <p className='sub-title'>お風呂の他、シャワー室あり</p>
          <p className='description'>エアコン・WiFi完備</p>
          <i className="fas fa-angle-down"></i>
        </a>
      </div>
      <div className='photos-row'>
        <a className='photos-cell photos-num3' href='/photosGarden'>
          <p className='title'>中庭にお部屋</p>
          <p className='sub-title'>お花、ハーブ、菜園に囲まれる空間</p>
          <p className='description'>風雅なティータイム</p>
          <i className="fas fa-angle-down"></i>
        </a>
        <a className='photos-cell photos-num4' href='/photosTerras'>
          <p className='title'>屋上テラス</p>
          <p className='sub-title'>30畳以上のスカイバルコニー</p>
          <p className='description'>家庭菜園</p>
          <i className="fas fa-angle-down"></i>
        </a>
      </div>
    </section>
    <section id='video' className='video'>
      <h2>ご紹介動画</h2>
      <iframe src="https://www.youtube.com/embed/U5PXWrpm9KY" frameBorder="0" allowFullScreen title='promotion'></iframe>
    </section>
    <section id='sns' className='sns'>
      <h2>SNS</h2>
      <a href='https://lin.ee/6xx4Ucw' className='sns-row'>
        <img className='image' src='images/line.png' alt='Line' />
        <span className='text'>LINE</span>
        <i className="fas fa-angle-right"></i>
      </a>
      <a href='https://www.facebook.com/%E9%A7%84%E8%8F%93%E5%AD%90%E5%B1%8B%E4%BB%98%E3%81%8D%E3%82%B7%E3%82%A7%E3%82%A2%E3%83%8F%E3%82%A6%E3%82%B9-110575301473690' className='sns-row'>
        <img className='image' src='images/facebook.png' alt='Facebook' />
        <span className='text'>Facebook</span>
        <i className="fas fa-angle-right"></i>
      </a>
      <a href='https://www.instagram.com/dagashi.ya/' className='sns-row'>
        <img className='image' src='images/instagram.png' alt='Instagram' />
        <span className='text'>Instagram</span>
        <i className="fas fa-angle-right"></i>
      </a>
      <a href='https://www.youtube.com/channel/UCA8Gd4tWw9GP26_JYmpRdnw' className='sns-row'>
        <img className='image' src='images/youtube.png' alt='Youtube' />
        <span className='text'>Youtube</span>
        <i className="fas fa-angle-right"></i>
      </a>
    </section>
    <section className='credit'>
      <div className='credit-row'>
        <a href='/contact' className='credit-cell'>
          <p className='text'><i className="far fa-envelope"></i> お問い合わせ</p>
        </a>
        <a href='/faq' className='credit-cell'>
          <p className='text'><i className="fas fa-question-circle"></i> よくあるご質問</p>
        </a>
      </div>
      <div className='credit-row'>
        <a href='/termsOfUse' className='credit-cell'>
          <p className='text'><i className="fas fa-file-contract"></i> 利用規約</p>
        </a>
        <a href='/privacyPolicy' className='credit-cell'>
          <p className='text'><i className="fas fa-key"></i> プライバシーポリシー</p>
        </a>
      </div>
    </section>
    <ScrollUpButton style={{width: 30, height: 30}} />
  </div>
)

export default TopPage


// WEBPACK FOOTER //
// ./src/TopPage.js